// THIS FILE IS AUTO GENERATED - do not edit!

import { forwardRef, type JSX } from 'react';

import { SvgIcon, type SvgIconProps } from '../lib/SvgIcon.js';

const TerminalIconComponent = /* @__PURE__ */ forwardRef<
  SVGSVGElement,
  SvgIconProps
>((props: SvgIconProps, forwardedRef): JSX.Element => {
  return (
    <SvgIcon data-iconname="TerminalIcon" ref={forwardedRef} {...props}>
      <path d="M9.997 11.5h4V13h-4z" />
      <path d="M10 10 7.173 7.172 6.11 8.232l1.768 1.767-1.766 1.766 1.06 1.064z" />
      <path d="M4 3a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V4a1 1 0 0 0-1-1zm.5 1.5h11v11h-11z" />
    </SvgIcon>
  );
});

/**
 * @public
 */
export const TerminalIcon = /* @__PURE__ */ Object.assign(
  TerminalIconComponent,
  { displayName: 'TerminalIcon' },
);
